import { z } from 'zod';

import { AccommodationFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Accommodation/schemas/AccommodationFormItemSchema';
import { AutomobileFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/schemas/AutomobileFormItemSchema';
import { FlightFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Flight/schemas/FlightFormItemSchema';
import { ProductFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Product/schemas/ProductFormItemSchema';
import { ServiceFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Service/schemas/ServiceFormItemSchema';
import { TravelFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Travel/schemas/TravelFormItemSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';

export const FormItemSchema = (t: GetTextIdTranslationType) =>
  z.discriminatedUnion('type', [
    ProductFormItemSchema(t),
    FlightFormItemSchema(t),
    AccommodationFormItemSchema(t),
    ServiceFormItemSchema(t),
    TravelFormItemSchema(t),
    AutomobileFormItemSchema(t),
  ]);
